import { SourceType } from './Enums';

export const SOURCE_DATA = 'SourceData';

export interface SourceData {
    sourceType?: SourceType;
    source?: string;
    sessionId?: string;
    first_name?: string;
    last_name?: string;
    phone?: string;
    email?: string;
}

export interface QueryStringSourceData extends SourceData {
    utm_knock_source_title?: string;
    referral?: string;
    referrer?: string;
    ssid?: string;
}

export const getSourceData = () => {
    var cachedSourceDataString = localStorage.getItem(SOURCE_DATA);
    return cachedSourceDataString
        ? (JSON.parse(cachedSourceDataString) as SourceData)
        : ({} as SourceData);
};

export const setSourceData = (queryData: QueryStringSourceData) => {
    var sourceType = SourceType.None;
    var source = '';
    var sessionId = undefined;
    if (queryData.utm_knock_source_title) {
        source = queryData.utm_knock_source_title;
        sourceType = SourceType.Knock;
    } else if (queryData.referrer === 'betterbot.ai') {
        source = queryData.source || 'BetterBot';
        sourceType = SourceType.BetterBot;
    } else if (queryData.referrer === 'hyly') {
        source = queryData.source || 'Hyly';
        sourceType = SourceType.Hyly;
        sessionId = queryData.ssid;
    } else if (queryData.referrer === 'funnel') {
        source = queryData.source || 'Funnel';
        sourceType = SourceType.Funnel;
    } else if (queryData.referral) {
        source = queryData.referral;
        sourceType = SourceType.Snippet;
    }

    const sourceData: SourceData = {
        ...queryData,
        sourceType,
        source,
        sessionId
    };

    localStorage.setItem(SOURCE_DATA, JSON.stringify(sourceData));
};

export const clearSourceData = () => {
    localStorage.removeItem(SOURCE_DATA);
};



// WEBPACK FOOTER //
// ./src/utilities/sourceData.ts